import { ApiError, Pagination } from '@connect-x-app/shared-domain-models';
import { AxiosError } from 'axios';

import { HttpClient, Params } from '../http';

export class AutocompleteClient {
  static async getAutoComplete(route: string, searchValue = ''): Promise<string[]> {
    const queryParams = AutocompleteClient.prepareParams(searchValue);
    try {
      const response = await HttpClient.get<Pagination<string>>(route, queryParams);
      return response.items ?? [];
    } catch (error) {
      const apiError = HttpClient.createApiError(error as AxiosError<ApiError>);
      throw Object.assign(new Error(apiError.message), apiError);
    }
  }

  private static prepareParams(searchValue: string): Params {
    let httpParams: Params = {};

    if (searchValue) {
      httpParams = { ...httpParams, searchValue };
    }

    return httpParams;
  }
}
